import { jsx } from "react/jsx-runtime";
import { Link, Box } from "braid-design-system";
import { root, disabledLink, linkUnderline } from "./MetaLink.css.mjs";
const MetaLink = (props) => {
  const {
    href = "",
    title,
    name,
    type,
    disabledLink: disabledLink$1 = false,
    isChild = false,
    rel,
    isSplitView,
    onClick
  } = props;
  const shouldAddUnderline = isSplitView && !disabledLink$1;
  const text = isChild && `(${name})` || name;
  if (title) {
    return /* @__PURE__ */ jsx(
      Link,
      {
        "aria-label": title,
        className: [
          root,
          { [disabledLink]: disabledLink$1 },
          { [linkUnderline]: shouldAddUnderline }
        ],
        tabIndex: disabledLink$1 ? -1 : void 0,
        title,
        href,
        rel,
        onClick,
        data: {
          type,
          automation: `job${type.charAt(0).toUpperCase()}${type.slice(1)}`
        },
        children: text
      }
    );
  } else if (name) {
    return /* @__PURE__ */ jsx(Box, { component: "span", children: text });
  }
  return null;
};
export {
  MetaLink
};
